export const WarningPanel = ({ children }: { children: React.ReactNode }) => (
  <div className="w-full py-6 px-4 border rounded bg-sun-2 text-lg leading-normal">
    <i className="mr-2 fa-regular fa-warning text-sun+2 font-black" />
    {children}
  </div>
);
